import {
  FilterMode,
  PaymentReceiptCreateMutationVariables,
  PaymentReceipt_OrderBy,
  PaymentReceipt,
  SortOrder,
  PaymentReceipt_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const paymentReceiptService = {
  createOne: buildCreateOne(
    (paymentReceiptCreateVariables: PaymentReceiptCreateMutationVariables) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.paymentReceiptCreate(
          paymentReceiptCreateVariables
        );
        return result.paymentReceiptCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.paymentReceiptOne({ id });
    return result.paymentReceiptOne as PaymentReceipt;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: PaymentReceipt_OrderBy[] | null = null,
    filter: PaymentReceipt_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: PaymentReceipt_Filter | undefined;
    if (searchValue !== "") {
      where = { crc: { contains: searchValue, mode: FilterMode.Insensitive } };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.paymentReceiptListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : [{ crc: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.paymentReceiptListWithOffset
    ) as PaymentReceipt[];
    return { list, orderBy };
  },
};
